import React from "react";

import { useTranslation } from "react-i18next";
import { AuthingButton } from "../../../components/AuthingButton";
import { DownRcode } from "../../../components/DownRcode";
import { tryNow } from "../../../utils";
import "./styles.less";

export const TenantBanner = (props) => {
  const { t } = useTranslation();

  return (
    <div>
      <section className="tenant-banner">
        <div className="identity-banner-container basic-column">
          <div>
            <div className="banner-title">{t("tenant.banner.title")}</div>
            <div className="subtitle">{t("tenant.banner.subtitle")}</div>
            <AuthingButton
              style={{ marginRight: 24, fontSize: 18 }}
              mode="dark"
              onClick={tryNow}
            >
              {t("common.button.try-now")}
            </AuthingButton>
            <DownRcode url="solution-mult-tenant-1.png">
              <AuthingButton style={{ fontSize: 18 }} mode="light">
                {t("solution.okta.banner.solution")}
              </AuthingButton>
            </DownRcode>
          </div>
          <div className="tenant-banner-img">
            <img
              src={`//files.authing.co/authing-website/${t(
                "tenant.banner.img"
              )}`}
              alt="authing"
            />
          </div>
        </div>
      </section>
      <div className="tenant-banner-data-warp">
        <div className="identity-banner-data basic-column">
          <div className="data-item">
            <div className="data-item-number">
              <span>88</span>
              <span className="data-item-character">%</span>
            </div>
            <div>{t("tenant.banner.data.item1")}</div>
          </div>
          <div className="data-item">
            <div className="data-item-number">
              <span>91</span>
              <span className="data-item-character">%</span>
            </div>
            <div>{t("tenant.banner.data.item2")}</div>
          </div>
          <div className="data-item">
            <div className="data-item-number">
              <span>96</span>
              <span className="data-item-character">%</span>
            </div>
            <div>{t("tenant.banner.data.item3")}</div>
          </div>
          <div className="data-item">
            <div className="data-item-number">
              <span>2</span>
              <span className="data-item-character">x</span>
            </div>
            <div>{t("tenant.banner.data.item4")}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
